import React from 'react';
import { Clock, Zap, Target } from 'lucide-react';
export function FeaturesSection() {
  return <section className="relative w-full bg-black py-20 md:py-32 font-['Inter',_sans-serif] overflow-hidden" data-id="element-4">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-amber-900/10 rounded-full blur-[120px] pointer-events-none" data-id="element-5"></div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-6">
        {/* Centerpiece Image */}
        <div className="flex justify-center mb-20" data-id="element-7">
          <div className="relative w-full max-w-2xl" data-id="element-8">
            {/* Decorative glow behind image */}
            <div className="absolute -inset-1 bg-gradient-to-r from-amber-500/30 via-yellow-300/30 to-amber-500/30 rounded-2xl blur-lg opacity-70" data-id="element-9"></div>

            <img src="https://cdn.magicpatterns.com/uploads/oDbnuhbUUF2jtaznSVkjzw/Designer_(1).png" alt="Pluma fuente escribiendo 3, 6, 9 en tinta dorada" className="relative w-full h-auto object-cover rounded-2xl border border-amber-500/20 shadow-2xl" data-id="element-10" />

            {/* Overlay gradient to blend bottom edge slightly */}
            <div className="absolute inset-0 rounded-2xl bg-gradient-to-t from-black/60 via-transparent to-transparent pointer-events-none" data-id="element-11"></div>
          </div>
        </div>

        {/* 3 Pillars Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 lg:gap-12" data-id="element-12">
          {/* Pillar 1 */}
          <div className="flex flex-col items-center text-center group" data-id="element-13">
            <div className="w-16 h-16 rounded-full bg-slate-900 border border-amber-500/30 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:border-amber-400 transition-all duration-300 shadow-[0_0_15px_rgba(245,158,11,0.1)] group-hover:shadow-[0_0_20px_rgba(245,158,11,0.3)]" data-id="element-14">
              <Clock className="w-8 h-8 text-amber-400" data-id="element-15" />
            </div>
            <h3 className="font-['Playfair_Display',_serif] text-2xl font-bold text-white mb-4" data-id="element-16">
              Resultados en{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 to-amber-500" data-id="element-17">
                1 Semana
              </span>
              .
            </h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-18">
              No necesitas meses de meditación. 7 días de enfoque cuántico para
              ver cambios reales en tu energía.
            </p>
          </div>

          {/* Pillar 2 */}
          <div className="flex flex-col items-center text-center group" data-id="element-19">
            <div className="w-16 h-16 rounded-full bg-slate-900 border border-amber-500/30 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:border-amber-400 transition-all duration-300 shadow-[0_0_15px_rgba(245,158,11,0.1)] group-hover:shadow-[0_0_20px_rgba(245,158,11,0.3)]" data-id="element-20">
              <Zap className="w-8 h-8 text-amber-400" data-id="element-21" />
            </div>
            <h3 className="font-['Playfair_Display',_serif] text-2xl font-bold text-white mb-4" data-id="element-22">
              Frecuencia{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 to-amber-500" data-id="element-23">
                3-6-9
              </span>
              .
            </h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-24">
              Usamos los números maestros de Nikola Tesla para reprogramar tu
              mente subconsciente mientras duermes y despiertas.
            </p>
          </div>

          {/* Pillar 3 */}
          <div className="flex flex-col items-center text-center group" data-id="element-25">
            <div className="w-16 h-16 rounded-full bg-slate-900 border border-amber-500/30 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:border-amber-400 transition-all duration-300 shadow-[0_0_15px_rgba(245,158,11,0.1)] group-hover:shadow-[0_0_20px_rgba(245,158,11,0.3)]" data-id="element-26">
              <Target className="w-8 h-8 text-amber-400" data-id="element-27" />
            </div>
            <h3 className="font-['Playfair_Display',_serif] text-2xl font-bold text-white mb-4" data-id="element-28">
              Cero Teoría,{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 to-amber-500" data-id="element-29">
                100% Acción
              </span>
              .
            </h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-30">
              Guía paso a paso: Qué escribir, qué agradecer y qué visualizar
              cada mañana y cada noche.
            </p>
          </div>
        </div>
      </div>
    </section>;
}